/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

Odigeo.defineWidget('membership_prices_tracker', Odigeo.Widget.extend({
    modelClass: require('./membership_prices_tracker.model'),
    trackMembershipPrices: function(isLoggedIn, isPrime) {
        if (!this.model.get('hasBeenEvaluated')) {
            this.model.trackPriceZero(isLoggedIn, isPrime);
        }
    },
    trackMembershipPricesDiscount: function() {
        this.model.trackPriceDiscount();
    },
}));
